// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-details-container .fi-content {
  padding: 20px 5px;
}
.fi-task-details-container .fi-content .task-details-main-wrapper .task-description {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task/task-details-container/task-details-container.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAGY;EACI,eAAA;AADhB","sourcesContent":[".fi-task-details-container {\r\n    .fi-content {\r\n        padding: 20px 5px;\r\n\r\n        .task-details-main-wrapper {\r\n            .task-description {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
